import differenceInHours from 'date-fns/differenceInHours'

export function getView(value) {
  return differenceInHours(new Date(), Date.parse(value.date)) <= 24
}
